import React from 'react';
import { ArrowRight } from 'lucide-react';
import { BusinessHero } from '@/components/ui/content-blocks';

const ShopwareHeader = () => {
  return (
    <BusinessHero
      title="Shopware für B2B & B2C"
      titleHighlight="B2B & B2C"
      description="Wir planen, entwickeln und optimieren Shopware-Shops, die verkaufen – von der ersten Idee bis zum Live-Betrieb."
      details="Egal, ob B2B oder B2C – mit unseren maßgeschneiderten Shopware-Lösungen steigerst du Conversion und Umsatz durch optimale Benutzerführung und nahtlose System-Integration."
      backgroundStyle="silver"
      primaryCTA={{
        label: "Mehr erfahren",
        href: "#shopware-features"
      }}
      secondaryCTA={{
        label: "Beratungsgespräch vereinbaren",
        href: "#contact",
        icon: <ArrowRight size={16} />
      }}
    />
  );
};

export default ShopwareHeader;
